import { Component } from '@angular/core';
import { App, NavController, NavParams, ViewController, LoadingController, AlertController, ModalController, PopoverController, Events, FabContainer, ToastController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { HttpProvider } from '../../providers/http/http';
import { FacturasPage } from '../facturas/facturas';
import { MonedaPage } from '../moneda/moneda';
import moment from 'moment'
import { MapaPage } from '../mapa/mapa';
import { File } from '@ionic-native/file';

/**
 * Generated class for the ClientesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-clientes',
  templateUrl: 'clientes.html',
})
export class ClientesPage {
  modal: any = false
  clientes: any = []
  aux: any = []
  resBusq: any = []
  user: any = {}
  filter: any = null
  skip = 0
  fin = 9
  btnCli: any = "A"
  skip_buscar = 0
  loading = false
  loadModal : any 
  busqueda: any = ''
  timeout: any = ''
  fechaAct: any
  actSearch = false
  cargando = false
  successs = false
  errorr = false
  super = false
  moneda: any = 'USD'
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public popCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public app: App,
    public file:File,
    public viewCtrl : ViewController,
    public events : Events,
    public http : HttpProvider,
    public alertCtrl: AlertController,
    public modlCtrl : ModalController,
    public toastCtrl: ToastController
    ) {
      events.subscribe('moneda:update', ()=>{
        this.updateMoneda()
      })
      this.init()
    }

  async init() {
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
    if(window.localStorage.getItem('super')){
      this.super = true
    }else{
      this.user.co_ven = window.localStorage.getItem('co_ven')
    }

    if(this.navParams.get('filter')){
      this.filter = this.navParams.get('filter').filter
    }
    if(this.navParams.data.modal){
      this.modal = this.navParams.data.modal
    }
    let cli = '[]'
    this.cargando = true
    if(window.localStorage.getItem('clientesrl')){
      cli = await this.file.readAsText(this.file.dataDirectory, 'avaflexclientes.json');
    }
    this.cargando = false
    cli = JSON.parse(cli)
    if (cli && cli.length > 0) {
      this.aux = cli
      this.skip = 0
      this.fin = 10
      if(this.filter !== null){
        if(this.filter === "M"){
          this.clientes = this.aux.filter(el=>{
            return el.saldo_deudor > 0
          }).slice(this.skip, this.fin)
          this.btnCli = "M"
        }else if (this.filter === "A") {
          this.clientes = this.aux.filter(el=>{
            return el.saldo_deudor < 1
          }).slice(this.skip, this.fin)
          this.btnCli = "A"
        } else if (this.filter == "C") {
          this.clientes = this.aux.filter(el=>{
            return el.saldoCXC > 0 && el.saldo_deudor <= 0
          }).slice(this.skip, this.fin)
          this.btnCli = "C"
        } else {
          let currentDate = new Date();
          let currentDay = currentDate.getDay(); 
          let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
          this.clientes = this.aux.filter(obj => {
            if (!obj.campo7) return false;
            let valores = obj.campo7.split(','); // Separar los valores por coma
            for (let valor of valores) {
              let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
              dayOfWeek = parseInt(dayOfWeek);
              weekOfMonth = parseInt(weekOfMonth);
              if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
                return true; // Si se encuentra una coincidencia, retornar true
              }
            }
            return false;
          }).slice(this.skip, this.fin);
          this.btnCli = "D"
        }
      }else{
        if (this.btnCli === "M") {
          this.clientes = this.aux.filter(el=>{
            return el.saldo_deudor > 0
          }).slice(this.skip, this.fin)
        } else if (this.btnCli === "A") {
          this.clientes = this.aux.filter(el=>{
            return el.saldo_deudor < 1
          }).slice(this.skip, this.fin)
        } else if (this.btnCli == "C") {
          this.clientes = this.aux.filter(el=>{
            return el.saldoCXC > 0 && el.saldo_deudor <= 0
          }).slice(this.skip, this.fin)
        } else {
          let currentDate = new Date();
          let currentDay = currentDate.getDay(); 
          let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
          this.clientes = this.aux.filter(obj => {
            if (!obj.campo7) return false;
            let valores = obj.campo7.split(','); // Separar los valores por coma
            for (let valor of valores) {
              let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
              dayOfWeek = parseInt(dayOfWeek);
              weekOfMonth = parseInt(weekOfMonth);
              if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
                return true; // Si se encuentra una coincidencia, retornar true
              }
            }
            return false;
          }).slice(this.skip, this.fin);
        }
      }
      this.skip+=10
      this.fin+=10
      this.getClientes2(this.user.co_ven, this.skip)
    } else {
      this.getClientes(this.user.co_ven, this.skip)
    }
  }

  verMapa(cli, fab: FabContainer){
    fab.close()
    let modl = this.modlCtrl.create(MapaPage, {value: cli})
    modl.onDidDismiss(data => {
      if (data) {
        let coordenadas = {
          co_cli: cli.co_cli.trim(),
          latitud: data.lat,
          longitud: data.lng
        }
        this.http.put('cliente/coordenadas', coordenadas).subscribe(
          (res:any)=>{
            this.getClientes2(this.user.co_ven, this.skip)
            this.alertCtrl.create({
              title: '¡Felicidades!',
              subTitle: 'Registro realizado exitosamente!',
              buttons:[
                {
                  text:'Aceptar',
                  cssClass:'btnAceptar',
                  handler:()=>{
                  }
                }
              ]
            }).present()
          }, err=>{
            console.log(err)
            this.alertCtrl.create({
              title: 'Atención',
              subTitle:err,
              buttons:[
                {
                  text:'Aceptar',
                  cssClass:'btnAceptar',
                  handler:()=>{
                  }
                }
              ]
            }).present()
          }
        )
      }
    });
    modl.present();
  }

  noActivacion(cli, fab: FabContainer){
    fab.close()
    let info = {
      co_ven: cli.co_ven.trim(),
      co_cli: cli.co_cli.trim(),
      estatus: "No activado"
    }
    this.http.post('activacion', info).subscribe(
      (res:any)=>{
        this.getClientes2(this.user.co_ven, this.skip)
        let title = res.success ? '¡Felicidades!' : 'Atención!'
        this.alertCtrl.create({
          title: title,
          subTitle: res.msg,
          buttons:[
            {
              text:'Aceptar',
              cssClass:'btnAceptar',
              handler:()=>{
              }
            }
          ]
        }).present()
      }, err=>{
        console.log(err)
        this.alertCtrl.create({
          title: 'Atención',
          subTitle:err,
          buttons:[
            {
              text:'Aceptar',
              cssClass:'btnAceptar',
              handler:()=>{
              }
            }
          ]
        }).present()
      }
    )
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  getClientes2(ven, skip){
    this.fechaAct = window.localStorage.getItem('horaClientes')
    if(window.localStorage.getItem('network') === '1') {
      this.cargando = true
      this.successs = false
      this.errorr = false
      const url = this.super ? `cliente/sup?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/ven/${ven}`
      this.http.get(url).subscribe(
        (res:any=[])=>{
          if (res && res.length > 0) {
            this.aux = res
            if (!this.actSearch) {
              if(this.btnCli === "M"){
                this.clientes = res.filter(el=>{
                  return el.saldo_deudor > 0
                }).slice(0, this.fin)
              }else if (this.btnCli === "A") {
                this.clientes = res.filter(el=>{
                  return el.saldo_deudor < 1
                }).slice(0, this.fin)
              } else if (this.btnCli == "C") {
                this.clientes = res.filter(el=>{
                  return el.saldoCXC > 0 && el.saldo_deudor <= 0
                }).slice(0, this.fin)
              } else {
                let currentDate = new Date();
                let currentDay = currentDate.getDay(); 
                let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
                this.clientes = res.filter(obj => {
                  if (!obj.campo7) return false;
                  let valores = obj.campo7.split(','); // Separar los valores por coma
                  for (let valor of valores) {
                    let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
                    dayOfWeek = parseInt(dayOfWeek);
                    weekOfMonth = parseInt(weekOfMonth);
                    if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
                      return true; // Si se encuentra una coincidencia, retornar true
                    }
                  }
                  return false;
                }).slice(0, this.fin);
              }
            }
            this.writeJSON('avaflexclientes.json', this.aux)
            // window.localStorage.setItem('clientes', JSON.stringify(this.aux));
            window.localStorage.setItem('horaClientes', moment().format('DD-MM-YYYY H:mm A'));
            this.fechaAct = window.localStorage.getItem('horaClientes')
          }
          this.cargando = false
          this.successs = true
        }, err=>{
          this.errorr = true
          this.cargando = false
        })
    } else {
      this.errorr = true
      this.cargando = false
      // this.alertCtrl.create({
      //   title: 'Atención',
      //   subTitle:'No se encuentra conexión con ninguna red.',
      //   buttons:[
      //     {
      //       text:'Aceptar',
      //       cssClass:'btnAceptar',
      //       handler:()=>{
      //       }
      //     }
      //   ]
      // }).present()
    }
  }

  close(){
    this.viewCtrl.dismiss()
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  ionViewDidEnter() {
    this.http.get('condicion').subscribe(
      (res:any)=>{
        if (res && res.length > 0) {
          window.localStorage.setItem('condiciones', JSON.stringify(res))
        }
      }
    )
  }

  changeData(item) {
    this.btnCli = item
    this.skip = 0
    this.fin = 9
    if (item === "A") {
      this.clientes = this.aux.filter(el=>{
        return el.saldo_deudor < 1
      }).slice(this.skip, this.fin)
    } else if (item === "M" ){
      this.clientes = this.aux.filter(el=>{
        return el.saldo_deudor > 0
      }).slice(this.skip, this.fin)
    } else if (item == "C") {
      this.clientes = this.aux.filter(el=>{
        return el.saldoCXC > 0 && el.saldo_deudor <= 0
      }).slice(this.skip, this.fin)
    } else {
      let currentDate = new Date();
      let currentDay = currentDate.getDay(); 
      let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
      this.clientes = this.aux.filter(obj => {
        if (!obj.campo7) return false;
        let valores = obj.campo7.split(','); // Separar los valores por coma
        for (let valor of valores) {
          let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
          dayOfWeek = parseInt(dayOfWeek);
          weekOfMonth = parseInt(weekOfMonth);
          if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
            return true; // Si se encuentra una coincidencia, retornar true
          }
        }
        return false;
      }).slice(this.skip, this.fin);
    }
    this.skip += 10
    this.fin += 10
  }

  showMonedas2(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  async writeJSON(filename, object) {
    let save = await this.file.writeFile(this.file.dataDirectory, filename, JSON.stringify(object), {replace:true})
    window.localStorage.setItem('clientesrl', 'true');
    return save
  }

  doInfinite(infiniteScroll){
    if (!this.actSearch) {
      if(this.filter !== null){
        if(this.filter === "M"){
          this.clientes = this.clientes.concat(this.aux.filter(el=>{
            return el.saldo_deudor > 0
          }).slice(this.skip, this.fin))
        }else if (this.filter === "A") {
          this.clientes = this.clientes.concat(this.aux.filter(el=>{
            return el.saldo_deudor < 1
          }).slice(this.skip, this.fin))
        } else if (this.filter == "C") {
          this.clientes = this.clientes.concat(this.aux.filter(el=>{
            return el.saldoCXC > 0 && el.saldo_deudor <= 0
          }).slice(this.skip, this.fin))
        } else {
          let currentDate = new Date();
          let currentDay = currentDate.getDay(); 
          let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
          this.clientes = this.clientes.concat(this.aux.filter(obj => {
            if (!obj.campo7) return false;
            let valores = obj.campo7.split(','); // Separar los valores por coma
            for (let valor of valores) {
              let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
              dayOfWeek = parseInt(dayOfWeek);
              weekOfMonth = parseInt(weekOfMonth);
              if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
                return true; // Si se encuentra una coincidencia, retornar true
              }
            }
            return false;
          }).slice(this.skip, this.fin));
        }
      }else{
        if (this.btnCli === "A") {
          this.clientes = this.clientes.concat(this.aux.filter(el=>{
            return el.saldo_deudor < 1
          }).slice(this.skip, this.fin))
        } else if (this.btnCli === "M") {
          this.clientes = this.clientes.concat(this.aux.filter(el=>{
            return el.saldo_deudor > 0
          }).slice(this.skip, this.fin))
        } else if (this.btnCli == "C") {
          this.clientes = this.clientes.concat(this.aux.filter(el=>{
            return el.saldoCXC > 0 && el.saldo_deudor <= 0
          }).slice(this.skip, this.fin))
        } else {
          let currentDate = new Date();
          let currentDay = currentDate.getDay(); 
          let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
          this.clientes = this.clientes.concat(this.aux.filter(obj => {
            if (!obj.campo7) return false;
            let valores = obj.campo7.split(','); // Separar los valores por coma
            for (let valor of valores) {
              let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
              dayOfWeek = parseInt(dayOfWeek);
              weekOfMonth = parseInt(weekOfMonth);
              if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
                return true; // Si se encuentra una coincidencia, retornar true
              }
            }
            return false;
          }).slice(this.skip, this.fin));
        }
        // this.clientes = this.clientes.concat(this.aux.slice(this.skip, this.fin))
      }
    } else {
      this.clientes = this.clientes.concat(this.resBusq.slice(this.skip, this.fin))
    }
    this.skip+=10
    this.fin+=10
    infiniteScroll.complete()
  }

  transform(value) {
    if(value){
      let val = value
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }


  irHome(cliente, fab: FabContainer){
    let ped = JSON.parse(window.localStorage.getItem('pedido'))
    fab.close()
    if (ped && ped.cliente && ped.articulos && ped.articulos.length > 0) {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'Actualmente posee un pedido en proceso del cliente: ' + ped.cliente.cli_des + ".",
        buttons:[
          {
            text:'Guardar',
            cssClass:'btn',
            handler:()=>{
              let subtotal = 0
              let iva = 0
              let total = 0
              ped.articulos.forEach(el=>{ 
                el.precio = el.precio
                subtotal += el.cant*el.precio.monto * el.equivalente
                iva += el.cant*el.precio.monto*(el.iva / 100) * el.equivalente
              })
              total += subtotal + iva
              ped.iva = iva
              ped.subtotal = subtotal
              ped.total = total
              let pede = []
              let pedidosE
              if (ped.nro) {
                pedidosE = JSON.parse(window.localStorage.getItem('pedidoEspera'))
                for (let i = 0; i < pedidosE.length; i++) {
                  let el = pedidosE[i];
                  if (el.nro === ped.nro) {
                    pedidosE.splice(i, 1)
                  }
                }
                pedidosE.push(ped)
                window.localStorage.setItem('pedidoEspera', JSON.stringify(pedidosE))
              } else if (window.localStorage.getItem('pedidoEspera')) {
                pedidosE = JSON.parse(window.localStorage.getItem('pedidoEspera'))
                ped.nro = pedidosE.length + 1
                pede = pedidosE
                pede.push(ped)
                window.localStorage.setItem('pedidoEspera', JSON.stringify(pede))
              } else {
                ped.nro = 1
                pede.push(ped)
                window.localStorage.setItem('pedidoEspera', JSON.stringify(pede))
              }
              ped = null
              window.localStorage.removeItem('pedido')
              this.events.publish('pedido:update')
              this.toastCtrl.create({
                duration: 4000,
                position: 'top',
                message:'Su pedido se ha sido guardado exitosamente.'
              }).present()
            }
          },
          {
            text:'Continuar',
            cssClass:'btnAceptar',
            handler:()=>{
              if(cliente.saldo_deudor < 1){
                let pedido = {
                  cliente: cliente
                }
                window.localStorage.setItem('pedido',JSON.stringify(pedido))
                this.navCtrl.push(HomePage,{pedido:true, cliente})
              }else{
                this.alertCtrl.create({
                  title: 'Atención',
                  subTitle:'Este cliente presenta facturas vencidas a la fecha, ¿quieres procesar un pedido de todas formas?',
                  buttons:[
                    {
                      text:'Cancelar',
                      cssClass:'btn'
                    },
                    {
                      text:'Aceptar',
                      cssClass:'btnAceptar',
                      handler:()=>{
                        this.navCtrl.push(HomePage,{pedido:true,cliente})
                      }
                    }
                  ]
                }).present()
              }
            }
          }
        ]
      }).present()
    } else {
      if(cliente.saldo_deudor < 1){
        let pedido = {
          cliente: cliente
        }
        window.localStorage.setItem('pedido',JSON.stringify(pedido))
        this.navCtrl.push(HomePage,{pedido:true, cliente})
      }else{
        this.alertCtrl.create({
          title: 'Atención',
          subTitle:'Este cliente presenta facturas vencidas a la fecha, ¿quieres procesar un pedido de todas formas?',
          buttons:[
            {
              text:'Cancelar',
              cssClass:'btn'
            },
            {
              text:'Aceptar',
              cssClass:'btnAceptar',
              handler:()=>{
                this.navCtrl.push(HomePage,{pedido:true,cliente})
              }
            }
          ]
        }).present()
      }
    }
  }

  irFacturas(cli, fab: FabContainer){
    fab.close()
    // this.navCtrl.push(FacturasPage,{ obj : { tipo: 'cli', cod: cli, moroso: (this.btnCli !== "A") ? true : false } })
    this.navCtrl.push(FacturasPage,{ obj : { tipo: 'cli', cod: cli, moroso: true } })
  }

  reset(){
    if(this.busqueda.length === 0) {
      this.resBusq = []
      this.actSearch = false
      if (this.btnCli === "A") {
        this.clientes = this.aux.filter(el=>{
          return el.saldo_deudor < 1
        }).slice(0, 9)
      } else if (this.btnCli === "M") {
        this.clientes = this.aux.filter(el=>{
          return el.saldo_deudor > 0
        }).slice(0, 9)
      } else if (this.btnCli === "C") {
        this.clientes = this.aux.filter(el=>{
          return el.saldoCXC > 0 && el.saldo_deudor <= 0
        }).slice(0, 9)
      } else {
        let currentDate = new Date();
        let currentDay = currentDate.getDay(); 
        let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
        this.clientes = this.aux.filter(obj => {
          if (!obj.campo7) return false;
          let valores = obj.campo7.split(','); // Separar los valores por coma
          for (let valor of valores) {
            let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
            dayOfWeek = parseInt(dayOfWeek);
            weekOfMonth = parseInt(weekOfMonth);
            if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
              return true; // Si se encuentra una coincidencia, retornar true
            }
          }
          return false;
        }).slice(0, 9);
      }
      // this.clientes = this.aux.slice(0, 9)
      this.skip = 10
      this.fin = 19
    }
  }

  buscar(){
    this.resBusq = []
    this.resBusq = this.aux.filter((el) => {
      let arry = this.busqueda.split(' ')
      if (arry.length === 1) {
        return el.cli_des.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1 ||
          el.co_cli.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1
      } else {
        let cont = 0
        let cont2 = 0
        for (let i = 0; i < arry.length; i++) {
          if (el.cli_des.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont++
          }
          if (el.co_cli.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont2++
          }
          el.puntuacion = (cont > cont2) ? cont : cont2
        }
        if (cont > 0 || cont2 > 0) {
          return el
        }
      }
    })
    this.resBusq.sort(function(a, b) {
      return b.puntuacion - a.puntuacion;
    });
    this.skip=0
    this.fin=9
    this.clientes = this.resBusq.slice(this.skip, this.fin)
    this.skip+=10
    this.fin+=10
    this.actSearch = true
    // if (this.btnCli === "A") {
    //   this.clientes = this.resBusq.filter(el=>{
    //     return el.saldo_deudor < 1
    //   })
    // } else if (this.btnCli === "M") {
    //   this.clientes = this.resBusq.filter(el=>{
    //     return el.saldo_deudor > 0
    //   })
    // } else {
    //   this.clientes = this.resBusq.filter(el=>{
    //     return el.saldoCXC > 0 && el.saldo_deudor <= 0
    //   })
    // }
  }

  getClientes(ven, skip, search=null, infiniteScroll=null){
    if(window.localStorage.getItem('network') === '1'){
      this.cargando = true
      this.successs = false
      this.errorr = false
      this.ActivarLoading()
      const url = this.super ? `cliente/sup?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/ven/${ven}`
      this.http.get(url).subscribe(
        (res:any)=>{
          this.DesactivarLoading()
          this.aux = res
          if(this.filter !== null){
            if(this.filter === "M"){
              this.clientes = res.filter(el=>{
                return el.saldo_deudor > 0
              }).slice(this.skip, this.fin)
              this.btnCli = "M"
            }else if (this.filter === "A") {
              this.clientes = res.filter(el=>{
                return el.saldo_deudor < 1
              }).slice(this.skip, this.fin)
              this.btnCli = "A"
            } else if (this.filter == "C"){
              this.clientes = res.filter(el=>{
                return el.saldoCXC > 0 && el.saldo_deudor <= 0
              }).slice(this.skip, this.fin)
              this.btnCli = "C"
            } else {
              let currentDate = new Date();
              let currentDay = currentDate.getDay(); 
              let currentWeekOfMonth = Math.ceil(currentDate.getDate() / 7);
              this.clientes = res.filter(obj => {
                if (!obj.campo7) return false;
                let valores = obj.campo7.split(','); // Separar los valores por coma
                for (let valor of valores) {
                  let [dayOfWeek, weekOfMonth] = valor.split('-'); // Separar el día de la semana y la semana del mes
                  dayOfWeek = parseInt(dayOfWeek);
                  weekOfMonth = parseInt(weekOfMonth);
                  if (dayOfWeek === currentDay && weekOfMonth === currentWeekOfMonth) {
                    return true; // Si se encuentra una coincidencia, retornar true
                  }
                }
                return false;
              }).slice(this.skip, this.fin);
              this.btnCli = "D"
            }
          }else{
            this.clientes = res.filter(el=>{
              return el.saldo_deudor < 1
            }).slice(this.skip, this.fin)
          }
          this.skip+=10
          this.fin+=10
          // window.localStorage.setItem('clientes', JSON.stringify(this.aux));
          this.writeJSON('avaflexclientes.json', this.aux)
          window.localStorage.setItem('horaClientes', moment().format('DD-MM-YYYY H:mm A'));
          this.fechaAct = window.localStorage.getItem('horaClientes')
          this.cargando = false
          this.successs = true
        },
        error=>{
          this.errorr = true
          this.cargando = false
          this.DesactivarLoading()
          if(search){
            this.loading = false
          }
          if(infiniteScroll){
            infiniteScroll.complete()
          }
          console.log(error)
          this.alertCtrl.create({
            title: 'Atención',
            subTitle:'No posee conexión a internet, intente nuevamente.',
            buttons:[
              {
                text:'Aceptar',
                cssClass:'btnAceptar',
                handler:()=>{
                }
              }
            ]
          }).present()
        }
      )
    } else {
      this.errorr = true
      this.cargando = false
      // this.alertCtrl.create({
      //   title: 'Atención',
      //   subTitle:'No se encuentra conexión con ninguna red.',
      //   buttons:[
      //     {
      //       text:'Aceptar',
      //       cssClass:'btnAceptar',
      //       handler:()=>{
      //       }
      //     }
      //   ]
      // }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/clientes/clientes.ts